import React from "react";
import { Box, Pagination, Button } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
export default function IntroductionPagination({ step, setStep, total, submit }) {
  const handleChange = (event, value) => {
    setStep(value);
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" mt={3}>
      <Pagination
        count={total}
        page={step}
        onChange={handleChange}
        color="primary"
        size="large"
      />
      {step === total && (
        <Box mt={2}>
          <Button variant="contained" onClick={submit} startIcon={<SaveIcon />}>
            Generate Timelines
          </Button>
        </Box>
      )}
    </Box>
  );
}
